import React from 'react';
import { t } from '@i18n';
import {
  Flex,
  Text,
  Alert,
  Divider,
  AlertTitle,
  AlertDescription,
} from 'ui';
import { style as s } from './FileWarningAlert.style';

export const FileWarningAlert = ({
  message,
  fileName,
}) => (
  <Alert {...s.alert}>
    <Flex {...s.flex}>
      <AlertDescription {...s.alertDescription}>
        <Text>{message || t('Common.na')}</Text>
      </AlertDescription>
      <Divider {...s.divider} />
      <AlertTitle {...s.alertTitle}>
        <Text>{fileName}</Text>
      </AlertTitle>
    </Flex>
  </Alert>
);
